export default {
  drawerSettings: {
    base: {
      /** `transitionTimeout` must be specified as a number (i.e. not as a string) in msec without unit e.g. 300 for 0.3s or 5000 for 5s */
      transitionTimeout: 300
    }
  },
  wrapper: {
    base: {
      backgroundColor: 'grey-0',
      width: ['296px', '400px', '480px'],
      position: 'absolute',
      right: '0px',
      p: '20px',
      height: '100vh',
      overflowY: 'auto',
      transition: 'transform 300ms ease',
      transform: ['translateX(296px)', 'translateX(400px)', 'translateX(480px)'],
      variant: 'spark.base.wrapper'
    },
    variants: {
      active: {
        variant: 'spark.element.drawer.wrapper.base',
        transform: ['translateX(0)', 'translateX(0)', 'translateX(0)']
      }
    }
  },
  close: {
    base: {
      marginBottom: '14px'
    }
  },
  title: {
    base: {
      fontFamily: 'base',
      fontSize: ['20px', '20px', 'md'],
      lineHeight: '1.2',
      fontWeight: '600',
      marginBottom: '14px'
    }
  },
  content: {
    base: {
      fontFamily: 'base',
      fontSize: 'base',
      lineHeight: 'base',
      fontWeight: 'base'
    }
  },
  closeBtn: {
    base: {
      display: 'block',
      mr: '0',
      ml: 'auto',
      position: 'relative',
      width: '24px',
      height: '24px',
      p: 0,
      border: 'none',
      cursor: 'pointer',
      color: 'unset',
      backgroundColor: 'transparent',
      appearance: 'none'
    }
  },
  closeImage: {
    base: {
      width: '24px',
      height: '24px',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }
};